import * as React from "react";
import { Namespace, useTypedT } from "@racoon/i18n";
import { useModal } from "@racoon/ui";
import { ModalHeading } from "~/shared/ui/modal-heading";
import { ForceCompleteShiftModal } from "./force-complete-shift.modal";

/**
 * Opens "Аварийное завершение смены" for a shift. `onCompleted` fires after the
 * backend has ended the shift, before the modal closes.
 */
export const useForceCompleteShiftModal = () => {
  const { openModal, closeModal } = useModal();
  const t = useTypedT(Namespace.ForceCompleteShift);

  return React.useCallback(
    (shiftId: bigint, options?: { onCompleted?: () => void }) => {
      // Dismissing mid-run would hide a half-settled shift; the run finishes first.
      let busy = false;
      const modalId = openModal({
        size: "2xl",
        width: { md: "min(1104px, 94vw)" },
        title: <ModalHeading as="span">{t("title")}</ModalHeading>,
        headerClassName: "!p-4 !pr-12",
        bodyClassName: "flex flex-col flex-1 !p-0 min-h-0",
        closeButtonTop: "top-4",
        onRequestClose: () => !busy,
        body: (
          <ForceCompleteShiftModal
            shiftId={shiftId}
            onClose={() => closeModal(modalId)}
            onCompleted={options?.onCompleted}
            onBusyChange={(next) => {
              busy = next;
            }}
          />
        ),
      });
      return modalId;
    },
    [openModal, closeModal, t],
  );
};
